export const infraConfig = {
    apiEndpoint : "https://minsidatd2-be.azurewebsites.net/api1",
    usePort: false,
    clientId: '9f380a1c-9111-4ea1-9106-a82103892d80', 
    identityServerEndpoint : "https://login.microsoftonline.com/b4518aa8-0d3e-4d10-bc77-4cd7dede3446/v2.0",
    documentsUrl: "https://minsidatd-docs.azurewebsites.net"
};

